import React, { useMemo } from 'react'

import Radio from 'components_new/atoms/Radio'
import { Color } from 'themes'
import { useCustomization } from 'redux/hooks/Customization'

interface ColorRadioProps {
  checked: boolean
  color: Color
  onChange: () => void
  sx?: object
  value: any
}

const ColorRadio = React.forwardRef((props: ColorRadioProps, ref: any) => {
  const { checked, color, onChange, sx, value } = props

  const customization = useCustomization()

  const customColor =
    color && customization.profile_colors
      ? customization.profile_colors[color]
      : undefined

  /*-- background color --*/
  const backgroundcolor = useMemo(() => {
    // custom
    if (customColor) {
      return customColor
    }

    // default
    return color ? `${color}.background` : 'grey.100'
  }, [customization.profile_colors, color])

  return (
    <>
      <Radio
        ref={ref}
        checked={checked}
        onChange={onChange}
        sx={{
          color: backgroundcolor,
          '&.Mui-checked': {
            color: backgroundcolor
          },
          ...sx
        }}
        value={value}
      />
    </>
  )
})

export default ColorRadio
